<template>
  <div>
    <van-row type="flex" justify="center" class="row-form">
      <van-col span="23" class="col-from">
        <van-field v-model="bdcqzs.bDCDYH" label="不动产单元号" readonly/>
        <van-field v-model="bdcqzs.bDCQZH" label="不动产权证号" readonly/>
        <van-field v-model="bdcqzs.bH" label="编号" readonly/>
        <van-field v-model="bdcqzs.iID" label="业务号" readonly/>
        <van-field v-model="bdcqzs.qLRMC" label="权利人名称" readonly/>
        <van-field v-model="bdcqzs.qLRZJMC" label="权利人证件类型" readonly/>
        <van-field v-model="bdcqzs.qLRZJHM" label="权利人证件号码" readonly/>
        <van-field v-model="bdcqzs.gYQK" label="共有情况" readonly/>
        <van-field v-model="bdcqzs.mJ" label="面积" readonly/>
        <van-field v-model="bdcqzs.yT" label="用途" readonly/>
        <van-field v-model="bdcqzs.zL" label="坐落" readonly/>
        <van-field v-model="bdcqzs.sYQX" label="使用期限" readonly/>
        <van-field v-model="bdcqzs.qLQTQK" label="权利其他情况" type="textarea" autosize readonly/>
        <van-field v-model="bdcqzs.sF" label="附记" type="textarea" autosiz readonly/>
        <van-field v-model="bdcqzs.dJSJ" label="登记时间" readonly/>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { getAtbdcqzs } from '@/api/atbdcqzs.js'
export default {
  filters: {
  },
  data() {
    return {
      bdcqzs:{}
    };
  },
  computed: {
  },
  created() {
  },
  mounted() { 
    this.loadAtbdcqzs();
  },
  methods: {
    loadAtbdcqzs(){
      getAtbdcqzs({
        ywh: this.$route.query.ywh
      }).then(response => {
        this.bdcqzs = response.data
      })
    }
  },
};
</script>
<style scoped lang="scss">
</style>